import { formatPriceForInput, formatPriceInput } from '@dashboard/services/formatting/price';

/**
 * The booking fee field is always shown; a blank amount means the ticket has
 * no fee. The decimal form value folds back into minor units on submit. The
 * fee's name is the theme label `bookingFeeText`, its display mode the ticket
 * group's `feeDisplay`.
 */
export function getTicketFeeFormValues(ticketType, currency) {
  const feeAmount = Number(ticketType?.feeAmount) || 0;

  return {
    feeAmount:
      feeAmount > 0 ? formatPriceForInput({ amount: feeAmount, currency, style: 'decimal' }) : '',
  };
}

export function prepareTicketFeeValues(values, currency) {
  const amount = values.feeAmount ? formatPriceInput(values.feeAmount, currency) : 0;

  if (!amount) {
    return { feeAmount: null };
  }

  if (amount < 0) {
    return { error: 'Fee amount must be greater than 0' };
  }

  return { feeAmount: amount };
}
